import { Component } from '@angular/core';

@Component({
  selector: 'idel-dev',
  templateUrl: './dev.component.html',
  styleUrl: './dev.component.scss'
})
export class DevComponent {

}
